import React, { useState, useEffect } from 'react';
import { BarChart } from '../../../common/ReusableComponent/Chart';
import { FaGamepad } from "react-icons/fa";
import { ImSpinner2 } from "react-icons/im";

const TopSellingGame = ({ activeThisMonth }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (activeThisMonth !== undefined) {
      setLoading(false);
    }
  }, [activeThisMonth]);

  const hasData = activeThisMonth && activeThisMonth.length > 0;


  const colors = [
    "#7ae2e2"
  ];

  const data = hasData
    ? {
      labels: activeThisMonth.map((game) => game.game_name),
      datasets: [
        {
          label: "Tickets Sold", 
          data: activeThisMonth.map((game) => game.total_sold_tickets),
          backgroundColor: activeThisMonth.map(
            (_, idx) => colors[idx % colors.length]
          ),
          borderColor: activeThisMonth.map(
            (_, idx) => colors[idx % colors.length]
          ),
          borderWidth: 1,
        },
      ],
    }
    : {
      labels: [],
      datasets: [],
    };

  return (
    <div
      style={{
        // padding: "24px",
        background: "#fff",
        boxShadow: "0px 2px 12px rgba(6, 12, 34, 0.08)",
        borderRadius: "20px",
        width: "100%",
        maxWidth: "900px",
        minWidth: "320px",
        minHeight: "340px",
        // margin: "20px auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "100%", marginBottom: 12, display: "flex", alignItems: "center", gap: 8 }}>
        {/* <FaGamepad size={24} color="#7ae2e2" /> */}
        {/* <h2 style={{ fontSize: 22, fontWeight: 700, margin: 0, color: "#222" }}>
          Top Selling Games This Month
        </h2> */}
      </div>
      {loading ? (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: 40 }}>
          <ImSpinner2 className="spin" size={36} color="#7ae2e2" />
          <span style={{ color: "#888", marginTop: 8 }}>Loading...</span>
        </div>
      ) : !hasData ? (
        <div style={{ textAlign: "center", marginTop: 40 }}>
          {/* <FaGamepad size={40} color="#eee" /> */}
          <p
            style={{
              fontSize: "17px",
              color: "#999",
              fontStyle: "italic",
              marginTop: 10,
            }}
          >
            No Top Selling Games this Month.
          </p>
        </div>
      ) : (
        <>
          <div style={{ width: "100%", maxWidth: 800 }}>
            <BarChart
              labels={data.labels}
              datasets={data.datasets}
              title="Top Selling Games This Month"
              theme="custom"
              noBorder
              height={"300px"}
              noShodow
              horizontal={true}
              options={{
                plugins: {
                  legend: {
                    display: false,     
                    onClick: () => { },  
                  },
                },
              }}
            />
          </div>
        </>
      )}
      <style>
        {`
          .spin {
            animation: spin 1s linear infinite;
          }
          @keyframes spin {
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default TopSellingGame;
